import React from 'react';
import { makeStyles } from '@mui/styles';
import Quotes from './Quotes';
import Highlight from '../Highlight';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '36px 0 0',
    // backgroundColor: theme.palette.background.default,
    [theme.breakpoints.down('md')]: {
      padding: '32px 32px 40px',
    },
  },
  container: {
    maxWidth: 665,
    margin: '0 auto',
  },
  title: {
    fontSize: 24,
    fontWeight: 600,
    margin: '0 0 20px',
  },
  text: {
    fontSize: 16,
  },
  cardsWrapper: {
    display: 'flex',
    margin: '40px 0',
    [theme.breakpoints.down('md')]: {
      margin: '32px 0',
      flexDirection: 'column',
    },
  },
  card: {
    flex: 1,
    padding: 20,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[4],
    borderRadius: 8,
    marginLeft: 24,
    '&:first-child': {
      marginLeft: 0,
    },
    [theme.breakpoints.down('md')]: {
      marginTop: 24,
      marginLeft: 0,
      '&:first-child': {
        marginTop: 0,
      },
    },
  },
  cardLabel: {
    textTransform: 'uppercase',
    fontWeight: 700,
  },
  cardContent: {
    textAlign: 'center',
  },
  wordBtn: {
    display: 'inline-block',
    marginTop: 12,
    fontSize: 21,
    lineHeight: '15px',
    fontWeight: 700,
    minWidth: 180,
    padding: '10px 0 12px',
    color: theme.palette.primary.contrastText,
    borderRadius: 8,
    textAlign: 'center',
  },
  nounBtn: {
    backgroundColor: theme.palette.primary.main,
  },
  verbBtn: {
    backgroundColor: '#8051FF',
  },
  wordText: {
    marginTop: 10,
    fontWeight: 600,
  },
  nounText: {
    color: theme.palette.primary.main,
  },
  verbText: {
    color: '#8051FF',
  },
}));

function Definition() {
  const classes = useStyles();

  return (
    <>
      <div className={classes.root}>
        <div className={classes.container}>
          <h2 className={classes.title}>Paraphrase Definitions</h2>
          <div className={classes.text}>
            <p>
              <Highlight>The word “paraphrase” has two definitions</Highlight>, depending on the
              part of speech it represents in the sentence.
            </p>
            <p>
              As a verb, “to paraphrase” means “to express the meaning of the writer or speaker (or
              something written or spoken) using different words, especially to achieve greater
              clarity.” As a noun, “paraphrase” is defined as “a rewording of something written or
              spoken by someone else.”
            </p>
          </div>
          <div className={classes.cardsWrapper}>
            <div className={classes.card}>
              <div className={classes.cardLabel}>Noun</div>
              <div className={classes.cardContent}>
                <div className={`${classes.wordBtn} ${classes.nounBtn}`}>Paraphrase</div>
                <div className={`${classes.wordText} ${classes.nounText}`}>
                  a rewording of something written or spoken by someone else
                </div>
              </div>
            </div>
            <div className={classes.card}>
              <div className={classes.cardLabel}>Verb</div>
              <div className={classes.cardContent}>
                <div className={`${classes.wordBtn} ${classes.verbBtn}`}>To Paraphrase</div>
                <div className={`${classes.wordText} ${classes.verbText}`}>
                  to express the meaning of the writer or speaker (or something written or spoken)
                  using different words, especially to achieve greater clarity
                </div>
              </div>
            </div>
          </div>
          <div className={classes.text}>
            Let’s look at it this way: if you were talking to a friend about what the characters
            said in your favorite scene of a movie, you wouldn’t repeat all of their lines word for
            word. Instead, you would give your version of what happened in the scene.
          </div>
        </div>
      </div>
      <Quotes />
    </>
  );
}

export default Definition;
